import React from 'react';
import FormikFieldWrapper from '../general/formikFieldWrapper/formikFieldWrapper';
import styles from './policyholderClaimRejectedForm.module.scss';
import { FormikValues } from 'formik';
import i18n from '../../i18n/i18n';
type Props = {
    rejectedReasonClaimReviewWordings: any;
    changeClaimReviewStateAction: any;
    formikProps: FormikValues;
};
const PolicyHolderClaimRejectedForm = (props: Props): JSX.Element => {
    const { rejectedReasonClaimReviewWordings } = props;

    return (
        <div id="rejected_claim_review_row" className={'row'}>
            <div
                id="rejected_claim_inputs"
                className="col-sm-12"
                style={{ marginBottom: '20px' }}
            >
                {rejectedReasonClaimReviewWordings.title}
            </div>
            <div className="row">
                <div id="rejected_claim_inputs" className={styles['container']}>
                    <FormikFieldWrapper
                        label={rejectedReasonClaimReviewWordings.subtitle}
                        variant={'textarea'}
                        inputProps={{
                            id: 'rejected_claim_reason',
                            name: 'acceptanceStatusReason',
                            required: true,
                            onInvalid: (
                                e: React.InvalidEvent<HTMLInputElement>,
                            ) => {
                                e.target.setCustomValidity(
                                    i18n.t('requiredField'),
                                );
                            },
                            onInput: (e: React.FormEvent<HTMLInputElement>) => {
                                (
                                    e.target as HTMLInputElement
                                ).setCustomValidity('');
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default PolicyHolderClaimRejectedForm;
